import { trans } from "utils/helpers"
import "./style.scss";
import { useEffect, useRef, useState } from "react";
interface ButtonPropsType {
    btnType: "submit" | "cancel" | "primary"|"primaryFill" | "cancelFill",
    onClick?: (e:any) => void,
    value: string | JSX.Element,
    disabled?: boolean
    Icon?: boolean
    outline?: boolean
    form?: string
    ref?: any
    customClass?:any
    tabIndex?:any
   
}
export const Button = ({ref, tabIndex,btnType, onClick, customClass,value,outline=true, disabled,Icon=false , form}: ButtonPropsType ,) => {

    const timeIDRef = useRef<any>(new Date().getTime() + "Button");


    useEffect(() => {
        
        let flag = true
        const callback = (event: KeyboardEvent) => {
            if (event.key === 'Tab') {
               //دراین شرط دکمه هایی را قرار میدهیم که اولویت اجرارویداد برای انها با والد است
               //برای مثال در فرم ها با دکمه تب نیاز ب جابجایی بین فیلد ها داریم و اگر این شرط نباشد دکمه تب عملی انجام نمیدهد چون اولویت اجرای رویداد با دکمه است  و ما نیاز داریم در این مورد اولویت اجرا با تگ والد باشد 
                return;
              }
            if(!Icon){

                if(( event.ctrlKey && event.keyCode == 83)&&btnType=="submit" ){
                    event.preventDefault()
                    event.stopPropagation()
                    document.getElementById(timeIDRef.current+btnType)?.click()
                    return false               
                } 
                if(event.key == "Escape"&&btnType =="cancel"){    
                    event.stopPropagation()
                    event.preventDefault()
                    document.getElementById(timeIDRef.current+btnType)?.click()
                    
                    return false
                }
            }
        };
      
            document.addEventListener('keydown', callback,true);

       
        return () => {
            document.removeEventListener('keydown', callback,true);
        };
    }, []);

    
    return (
        <>
        {typeof (value) == "string" ?
        <button tabIndex={tabIndex} id={timeIDRef.current+btnType} ref={ref}  form={form} disabled={disabled} type={`${btnType=="submit"? "submit":"button"}`} className={`${customClass} tabEnd active-class button-custom mx-1 btn ${btnType == "submit" ? Icon ?  "check" : ("btn" + `${outline?"-outline":""}` +"-success " ): (btnType == "cancel" ? "btn-outline-danger " : (btnType == "primaryFill" ? "btn-primary":btnType =="cancelFill"? "btn-danger": "btn-outline-primary " ))} `} onClick={onClick}>
            {typeof (value) == "string" ? trans(value) : value}
        </button>
           : value
        }        
        </>

    )
}